import React from 'react';
import { useSelector } from 'react-redux';

export const Info = () => {

    const config = useSelector(state => state.config.data);

    return (
        <>
            {config?.showHomeBanner && <div className="alert alert-warning" role="alert">
                <h3>Attenzione!</h3>
                <span>{config?.homeBannerMessage || "This is a warning alert—check it out!"}</span>
            </div>}
            <div className='row justify-content-around animate__animated animate__fadeIn'>
                <div className='col-12 col-md-6 pt-3 pr-3 pl-3 pl-md-5' style={{ borderRadius: '10px' }}>
                    <div className="card shadow-lg mb-3">
                        <div className="card-header text-center text-white bg-primary">
                            <h2 className="card-title m-0">Link Utili</h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className='col-12 col-md-6 text-center'>
                                    <h5 className='card-title text-center'>
                                        Videotutorial :
                                    </h5>
                                    <a aria-label="link dove scaricare i video tutorial"
                                        href='http://store.regione.toscana.it/filedownload/REC/' target='_blank'
                                        rel="noopener noreferrer">
                                        http://store.regione.toscana.it/filedownload/REC/
                                    </a>
                                </div>

                                <div className='col-12 col-md-6 text-center'>
                                    <h5 className='card-title text-center'>
                                        Pagina servizi RT :
                                    </h5>
                                    <a aria-label="link home page servizi offerti da Regione Toscana"
                                        href='https://www.regione.toscana.it/formazione/servizi' target='_blank'
                                        rel="noopener noreferrer">
                                        https://www.regione.toscana.it/formazione/servizi
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
